/**

 Registriert SignalEvents:
 =========================

 markermouseover (map:ym.map.CMap, event:Object)
 markermouseout  (map:ym.map.CMap, event:Object)
 markerclick     (map:ym.map.CMap, geoPosition:ym.geo.CGeoPoint, pixelPosition:ym.common.CPixel)
 markermousedown (map:ym.map.CMap, geoPosition:ym.geo.CGeoPoint, pixelPosition:ym.common.CPixel)
 markermouseup   (map:ym.map.CMap, event:Object)

 */
function CGeocoderSignals(/**ym.event.CEventEmitter*/signals) {
    this.signalsObject = signals;
    this.geocoder = new ym.geo.CGeocoder();
}

CGeocoderSignals.prototype = {
    constructor: CGeocoderSignals,

    reverseGeocode: function (/**ym.geo.CGeoPoint*/location) {
        var self = this;
        self.signalsObject.emit('reversegeocodebefore', self.geocoder, location);
        self.geocoder.reverseGeocode(location, function (data) {
            self.signalsObject.emit('reversegeocodesuccess', self.geocoder, data);
        });
    },

    reverseGeocodeCountry: function (/**ym.geo.CGeoPoint*/location) {
        var self = this;
        self.signalsObject.emit('reversegeocodebefore', self.geocoder, location);
        self.geocoder.reverseGeocodeCountry(location, function (data) {
            self.signalsObject.emit('reversegeocodesuccess', self.geocoder, data);
        });
    },

    geocode: function (/**ym.geo.CAddress*/address) {
        var self = this;
        self.signalsObject.emit('geocodebefore', self.geocoder, location);
        self.geocoder.geocode(address, function (data) {
            self.signalsObject.emit('geocodesuccess', self.geocoder, data);
        });
    },

    geocodeString: function (/**string*/addressString) {
        var self = this;
        self.signalsObject.emit('geocodebefore', self.geocoder, location);
        self.geocoder.geocodeString(addressString, function (data) {
            self.signalsObject.emit('geocodesuccess', self.geocoder, data);
        });
    },

    calcIsochrone: function (location, isochroneSeconds, isochroneMeter, additions) {
        var self = this;
        self.signalsObject.emit('calcisochronebefore', self.geocoder, location);
        self.geocoder.calcIsochrone(location, isochroneSeconds, isochroneMeter, function (data) {
            self.signalsObject.emit('calcisochronesuccess', self.geocoder, data);
        }, additions);
    },

    calcRoute: function (/**(string|object|ym.geo.CGeoPoint)[]*/stations, additions) {
        var self = this;
        _.each(stations, function (station, index) {
            if (typeof station === 'string') stations[index] = _extractSingleSlotGeo(station);
        });
        self.signalsObject.emit('calcroutebefore', self.geocoder, location);
        self.geocoder.calcRoute(stations, function (data, additions) {
            self.signalsObject.emit('calcroutesuccess', self.geocoder, data, additions);
        }, additions);
    }
};
